module.exports = new __parcel__URL__("Paladinskill_46.dcf0ef4b.png").toString();